import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import './design-guidelines-styles.css';
export const _frontmatter = {
  "pageTitle": "ButtonGroup Design Guidelines",
  "title": "ButtonGroup",
  "order": 1
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const LeadParagraph = makeShortcode("LeadParagraph");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <PageContent componentName="buttongroup" type="design" mdxType="PageContent">
      <LeadParagraph mdxType="LeadParagraph">
  The ButtonGroup component can be used to group related buttons.
      </LeadParagraph>
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "45.55984555984556%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAIAAAC9o5sfAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAn0lEQVQoz6WQywrCMBBF89WCuPBbRPRTdO2DurS4EClJk3aSm4cpEbqxELQ+znLgzNy5zPwBy0fo+UUmoqbnaxmAEOLao5QaBgGgtR6/LKWs65pz3jTKWhuC66Lvos919ioSgIobLrA7VNP5djLb7I+3eLfDBezNS21rYX15kcv1abEqzqXwHsPjbKwU7RxSCikF5/Bp7KetDZEmyvsyD/+S/4Z53xDzAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": " ",
            "title": " ",
            "src": "/version/4.9.0/static/e615d41efaf677214f6510209e1d0577/e3189/button-group-intro.png",
            "srcSet": ["/version/4.9.0/static/e615d41efaf677214f6510209e1d0577/a2ead/button-group-intro.png 259w", "/version/4.9.0/static/e615d41efaf677214f6510209e1d0577/6b9fd/button-group-intro.png 518w", "/version/4.9.0/static/e615d41efaf677214f6510209e1d0577/e3189/button-group-intro.png 1035w", "/version/4.9.0/static/e615d41efaf677214f6510209e1d0577/aa440/button-group-intro.png 1500w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span></p>
      <hr></hr>
      <h2>{`Options`}</h2>
      <h3>{`Orientation`}</h3>
      <p>{`ButtonGroup can be either horizontal or vertical in its orientation. By default, ButtonGroup is horizontal. Use the vertical option when horizontal space is limited.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "93.05019305019306%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAIAAAAf7rriAAAACXBIWXMAAAsTAAALEwEAmpwYAAABzElEQVQ4y6VUQWsTQRTOr/Fc8CR461E9KAhSb7UXUQRR8KAgFnvpz7CUtGjAQ0ErlqIeqmgskYDbBNPd7m62iZ0kOzPvvZnZ3a7sEmjY1pDQj3cZmG/mm+97b0pwDpQKazmC6ciISEQqByJOSpZSKqWCIKjX65Zl1Wq1VqullJJSEiERKspOK6g5uRkBOBf9/oALPghDwQUAMsZth9kHbN9mrtfnXOJ/ZEsA1R8Y15NeG9oBRFHycvnHtZvv5+9uL9z7NHt14+O2naaaC3kmmcLQ2A73fOh0MI6Tpy++zV7ZmJvfun1n6+LlyrsPrTQ1nJ9BBiGkEKAoAyIBoOv1qrvtrH62f9UPez0+6mPRbWO0Uhk9FwLGYJrqYR1rIhz17MRtIjo6Ynt7zWbzj+8HQqIQWdq5nGGNyRml5N2uHwRuGLLjREcRTZSzEDJJVHU3ePhk5/lS9dni9wePv6yUf0cRjWm1IZlzmaam8rZxYWb9xtzm9VubM5cq9x99TmJ1Wu3pN4PWuG+zlbJVftNYe914tWrtfPW1xjE9Xhodibyt48MOsB5JMErF46ejkDN2/5LtcOdAOK4YhGoKcr4V85ixEOlE83yuz2Aq8j8yaRznEHHHUQAAAABJRU5ErkJggg==')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.0/static/4a0fdce1462f6aff0fb3f651e27db66a/8ae3e/orientation.png",
                  "srcSet": ["/version/4.9.0/static/4a0fdce1462f6aff0fb3f651e27db66a/a2ead/orientation.png 259w", "/version/4.9.0/static/4a0fdce1462f6aff0fb3f651e27db66a/6b9fd/orientation.png 518w", "/version/4.9.0/static/4a0fdce1462f6aff0fb3f651e27db66a/8ae3e/orientation.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
  `}</div>
        </div></div>
      <h3>{`Size`}</h3>
      <p>{`ButtonGroup comes in three different sizes: small, medium, and large. The medium size is the default and most frequently used option. Use the other sizes sparingly; they should be used to create a hierarchy of importance within the page.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "93.05019305019306%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAIAAAAf7rriAAAACXBIWXMAAAsTAAALEwEAmpwYAAACZ0lEQVQ4y5WSS08UQRSF5w+5URNNJCYuWBnjgxAFQqJsjBsTjIks3PkDBAQmhkQRHyuDgiDydgELdz0wDEG6BxAYepjGnqq6VXWreugyzTwlCPHmLGpRJ+fUVzfGyyOlRET+PxPjnAshKKWum81kMoQQIQRjQA8FAKebCSG2vba6ukIpQRRhqIyJpJQ4wR6rnCjVfl4Tim6Wvh5c7h9I9vUvJZfdQMt/+UtmxnhmF9IbJLsn1hy/6d50S9vs1YbxL18dYxRlcEqykBEyAAGcex7J7OZdN3/ik8tmSqkXTc73fc4BUSAKITilUBQ7LrwELJ/3k8mkZSVs22YsooxSmBBNmZzWx5Cr1gZAIZQQyEByITc2f4+OO6Pjztg3Z2TMSa3sIR71V4EB6F9bLL1O0uvUGPPq7crZS0ONrdONrdPnL396+uxHGOKR8lUzY8rbF96+zHnCmIOp2c22B3OPOhbaOxbu3p8b/JAqFJABHF+7uKAAHCDihDIqSUhEC4AjihP+meVyOdd1AUBECCsgIs6MAaGlQ23z6no6jrO4uOT7hDFOy1eDQBqj/5aSskQuVk7gnCutC0ppVFopzTlKiTPfNzt7rZ6Xie649SKe6I4n3rxPefu06C8mR1FBcODncWub7WT49g5IWTDGtD+ZP1c3dOPOxK3myYbmyfprY3X1wz/XcoGWDKCyYTwIDtyssNPUXqdOmvq+MsY8fDx/5sLHhpapm02T129P1NUPX7zy+aiZAWcgUenyBNHCSJyZ23jeY3XHrc5eq6vP6upLDLxLeV5N7eqO1cwhBggCNCaoVRiqyl/8AQrABPLGeFSzAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.0/static/6a7b197c36a0bdad07e0b2a8e7f46cad/8ae3e/size.png",
                  "srcSet": ["/version/4.9.0/static/6a7b197c36a0bdad07e0b2a8e7f46cad/a2ead/size.png 259w", "/version/4.9.0/static/6a7b197c36a0bdad07e0b2a8e7f46cad/6b9fd/size.png 518w", "/version/4.9.0/static/6a7b197c36a0bdad07e0b2a8e7f46cad/8ae3e/size.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
  `}</div>
        </div></div>
      <h3>{`No Space`}</h3>
      <p>{`You can easily remove the space between buttons to create a single unit. When you join buttons like this together, there typically isn't a hierarchy within their relationship, so it is acceptable to use the same button style. This property is not intended for vertical ButtonGroups.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "33.59073359073359%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAIAAACHqfpvAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAoElEQVQY06VQuw6CQBDk/3/GQgs/wMTa2BgbDyMI4XH7uJ3DziCSINixmWJ2spvZ2cRWVGJmQI+BLNup8mdZ1bwPIsZsImjbUNcqYqNiRF8yIOi4DBgxTucmy+2RhbrpLlfa7e9FiZsTl6r3r8Ox2Gxd/oRLNcshgh9nIhD1tsQggvfGH8IMYVSVlqUMM0RQnZw9y7lEjNZFM8zDJ2u+/Qak/42oIDGrigAAAABJRU5ErkJggg==')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.0/static/b995f445e6b3c20754f4a23ba05675bb/8ae3e/no-space.png",
                  "srcSet": ["/version/4.9.0/static/b995f445e6b3c20754f4a23ba05675bb/a2ead/no-space.png 259w", "/version/4.9.0/static/b995f445e6b3c20754f4a23ba05675bb/6b9fd/no-space.png 518w", "/version/4.9.0/static/b995f445e6b3c20754f4a23ba05675bb/8ae3e/no-space.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
  `}</div>
        </div></div>
      <hr></hr>
      <h2>{`Usage Guidelines`}</h2>
      <h3>{`Use the recommended option for subsequent actions`}</h3>
      <p>{`The most critical action within a ButtonGroup should be a primary, marketing, or danger button (fill or outline). The other actions should always be a secondary outline button. If all of the buttons are of equal importance, the buttons can all use the same variant.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "964px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "72.97297297297297%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAIAAABr+ngCAAAACXBIWXMAAAsTAAALEwEAmpwYAAABtklEQVQoz8VSy24TQRDcP8kBfoCHEPkAuMCHwJkDF34hVw4EhHgoQeQGAi6RJZyEu2UTQMTB8iPerHdnd6e7a2bH4EFjE28iwQEutEojjdQ1VdU90b03a5oIAhaWv6xorbFOvCD/vohY6xp8qi/y7geAP73NLM5hNrNLGFPLRIun5gcAAxhmEIVrANAfqFY77uwftz/Gnf1YKb3UihYCImaS2oNDPRwJyxSYxrEZDMV7f+fu7qXVrWs3Xl2/+frC1a3txjfvK028JAdlrVEUyHOQBrMpywDn3PbO0f1nXx9udh+96D7YOOj2cldhkbwmlxpliVIbIhCh1ChyJjstPjSzp+v5y+fZ5hO18Zj7PamqRc7adqaqwx4Nj8DiYKZJYuIxz7z/cvtW6/xK+8rFzurl1rmV5N1b4z1rfUaZBTBhYHPlMD0ICDb//Em9b+R7O/leU+02KTkWY04rCzPy3MQxpxmYLbNVCmkKEUvGKeMnNEvIl5UXY+Vk10uyyZQdDHk0BnEFuCQ1yQS2+l4UGI/0eKQH/TJNRLj+FLVtkeBaJEzy154R/DPPI4RAOOk8S/63+n/kn4W2PjhvyQobAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.0/static/9a268ab0d890fbdd45f3eae66dfd234b/72aae/good-groupings.png",
                  "srcSet": ["/version/4.9.0/static/9a268ab0d890fbdd45f3eae66dfd234b/a2ead/good-groupings.png 259w", "/version/4.9.0/static/9a268ab0d890fbdd45f3eae66dfd234b/6b9fd/good-groupings.png 518w", "/version/4.9.0/static/9a268ab0d890fbdd45f3eae66dfd234b/72aae/good-groupings.png 964w"],
                  "sizes": "(max-width: 964px) 100vw, 964px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "964px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "72.97297297297297%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAIAAABr+ngCAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB1ElEQVQoz6WSS2sTURTH8z1cuXEl6KaLbOzCByJF8Lvoqt9BcKtYjcUWhPQRDC7EZ0uwsSC1eUgzobHJJDOZJjNz73lNks5InGYSULuwh//iHs753XseN9V69BD/11KdzBISnZGhNSg1FcAMzGF4BgyAgwGFoSRipgRP4eQqImQiZkpcRGTGZrO/t2+VKvZ+2SpVrH5fJW+lTlMRzOZxudw2Dmztj8ONnz2jfhyF8mCxcDWdvb6Qv7GQv5LOvn3fiKJAaZjAACiih6HHI5eHODpBRNdTnqeDgD5vHz3NlF+sVJdXq5mXlcNGLwgoLndcNg0Gft3oLD22lp9bz57YuQ0AVoo9j0SC4q75au1g87WxlqtlN2st0xWZwKAUR1E3t/H94oXqfLp0+dKPOzeZAtuRdgejKLq/WJibX791N3/73pu5a+vvPsyWDYDM2rL625+8wpa79dHd+6aBiDhWzXAKX5rFXXPnq7lTbDmOPx444LRnEnHlpOMFDgxpNELEruPbXU8DiAREA6VEKREZEvF0z8m07XbPqNmH9a72fSJsma7ZdgFAaWma0DKhcaTtLgP8Af9eLImMFbvMpzsHGIfiJmL3L3AcSGKz53/+bTyHnQv+BffEM1ZYQD2dAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.0/static/082b3d478b28055e63e8cdc7499f8c09/72aae/bad-groupings.png",
                  "srcSet": ["/version/4.9.0/static/082b3d478b28055e63e8cdc7499f8c09/a2ead/bad-groupings.png 259w", "/version/4.9.0/static/082b3d478b28055e63e8cdc7499f8c09/6b9fd/bad-groupings.png 518w", "/version/4.9.0/static/082b3d478b28055e63e8cdc7499f8c09/72aae/bad-groupings.png 964w"],
                  "sizes": "(max-width: 964px) 100vw, 964px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
      `}</figure>{`
    `}</div>{`
  `}</div>
      </div>
      <h3>{`Align ButtonGroups based on content`}</h3>
      <p>{`ButtonGroups are aligned contextually. In general, ButtonGroups are left-aligned to follow content such as a block of text. They can be center-aligned if that block of text is also center-aligned. And, they should be right-aligned inside container components such as modals, or cards.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "964px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "127.02702702702702%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAZCAIAAAC+dZmEAAAACXBIWXMAAAsTAAALEwEAmpwYAAACMElEQVQ4y9WUu2/TUBTG8wexMrOWERYGBiQmxAAsLCwMDEgsLEhlgH+ABaltkkZ5Va1EHo1SoBIl5Fn6iGM7dnJf59r32kbONY7TNFUXBj795Me1Pp/zWec69Tq//ir3znMkpUS4sAyllJAFYqXKrUrmsCwc17bRr46VpNW22l2LUuo4jPMIxhJm6UjpSAA60lFxRyuU5+RLWnFHa3fswfG0P4iwbRL7U5hghDEA00YoX9KXSW9rW9mIzYz2+2TKOVPNp9Q7AKhp4kZzvEy1blZqEV+q5lBDAHTBzBidTEi3ZyfpdO1e3+acSsmEiFjIrD5mlLl8SeZW2+4NJt3+jN7EsvA8c2yeZR7FFEq6IpPT0tsRW9kVmQ0D1/ZNRaVmVOqzY82IF2v7ZrVuaqOlzH9jY3OMxhYi4S0DCFGPACKSUm0TKeDrd+3+w+LjZ3v3HhTevD2gzD09I+dDipCD0IoJU5mFC0c/9SfP9168rD56uvv+4yED92xIdIMixJOGi5WVn3Pm+1wI7nlcSk5puKLaXqV5ZkIIQhhjghAJT2GHsa40A4BzbXHOF8xSyuDaklL+F2bP86WMmF3/08qu63HuMZB+EHR608+b/UzueCM9KO+eC3Gl2fcDQsTJKW61J0EQrH/4cePmp7U72VtrG7fvZilzAcKNtbKykH6I8Hw/0A1oNPWDb0ajqR+17Ittz7bO5aKUuS4EgavwfSf+m6RWzW1yJDEmU4QVCOF4PP8A4zxuc6h8gb0AAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.0/static/89ab0367c20e773be2bf65e54486ae94/72aae/alignment.png",
                  "srcSet": ["/version/4.9.0/static/89ab0367c20e773be2bf65e54486ae94/a2ead/alignment.png 259w", "/version/4.9.0/static/89ab0367c20e773be2bf65e54486ae94/6b9fd/alignment.png 518w", "/version/4.9.0/static/89ab0367c20e773be2bf65e54486ae94/72aae/alignment.png 964w"],
                  "sizes": "(max-width: 964px) 100vw, 964px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
  `}</div>
        </div></div>
      <h3>{`Respect button order within a group`}</h3>
      <p>{`The order of button priority should match the alignment of surrounding text. When text is left-aligned, buttons should be arranged so that the leftmost button is the most critical. When text is right- or center- aligned, the most critical action should be the furthest right.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "964px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "164.0926640926641%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAhCAIAAABWXBxEAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC1klEQVQ4y82Vu08UQRzH7x+iJhY2FsZGEwtDKR0NlSYWhsTEyljYW5hoQSGBBIFjlz3uwQWiSIgSCUQeItxjZ4+D23nP7M7umLk9jjsex1mY+M0nm7lsvvO7md93ZlOvs28/rE7FMiKEMEZvpFOpd58nJtbTcaAQxqcN0rgJTDrMkVRKKiFopYqcrJcr1LLXkCvUnKznAiQEJc0pUoQQjIkQrFyBlgMyOc/JXk0m51kOcF0kBGuZKTXTCMFKZTiTrs4vuGnbnV9w7YyXYGWMx3KAnQFzllu9YE5ECIWQ+ZAhxOp1clTyS2XYpD2ARyUIIWlv23nlSrUxM79nOb8+ze1u/ABhIDFmlHLOOOdMiBadG27MCBOtpZM9GBicfDC0MDA49fzFqtZ6bx+VyhSTECFTIKGrVa3KnAHgO7mDxfxvK3OwtV0TXGDCMTaroNfofM2MURUKpQzybEt6K9X5o/Xfzubqka0rzIkQIj68CEKkl5kQ6kOCCdncOskX3eIKaJMvuptbJ5iYWTqX024Vrboot1QrLh8XirX8JQpF8yq3VANeRzzbfS5X4Jzt2ougnS0746UXQNp2E6wMmLOvShhjFELiAgQ8BJJnc9BoUB9S3zfUjrELEELdCWuLczMLoRxhjhDjXOQKh+Mftyemfk5O79TrUErWq1WYMB8G+weoXKGcq+GR/O27s/ceWrfuTJvMhgJ3HOiLrTJ+zAhpsbN7vLpWWVuvfttwIcQXb5Lr82MqhCHXsdSxiCNxOSep3gHE2MQjoa+E9a+WOQgC1beCIOgyR1Gk+5ZS6n82x7FBax3FsVJxFCX868qUhsd17tW41np2/nD0yfLYy6/Pxr68evOd88AcAXK9GeMQAH54hLXW78d37j+yh0fyQ48XR5+uUCq7zGEYRt1SSrUGoZIy9H3RaPCTU05poFSYXCh9JYwxKiWTkktpPgB/F8/mUSMtOi6xP8DHKnsYcsPaAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.0/static/a98d3bc0c1812ecc6897c021f5c09dc9/72aae/button-order-good.png",
                  "srcSet": ["/version/4.9.0/static/a98d3bc0c1812ecc6897c021f5c09dc9/a2ead/button-order-good.png 259w", "/version/4.9.0/static/a98d3bc0c1812ecc6897c021f5c09dc9/6b9fd/button-order-good.png 518w", "/version/4.9.0/static/a98d3bc0c1812ecc6897c021f5c09dc9/72aae/button-order-good.png 964w"],
                  "sizes": "(max-width: 964px) 100vw, 964px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "964px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "51.35135135135135%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAAsTAAALEwEAmpwYAAABE0lEQVQoz4WQy0rDQBSG+4DiSnHl3p1P4sYidiO4cOEbVBvrZSEiLqQroRSpmJhMm5kkc26TRIrQlqQttf35FsPhfDPD3wgvL4LWGU8mhOAcb4WpTsO8veqXZy4Lm0EY2a1kGVYXNLgsufwVoTCyN57aTLujvv3MOUacygSAACIcKevdq810uspfkokQSYSUst3HUcWiUw3vHkZBYJ2jWp4FALUGY1AbiDUAMOIcbTDWMMNarAurTogE6GLNaSrE7ur64+T0vXnea7Z6xth82rMsdr0sc5Lmn0P4CdlCfnT8tHtwu3/o7ey1/SBxwgDz365/GZGZmZiROAiS/mDcH4yHX3rFWSOvxDkuCikKyXP5b+cP7bYdnJq5VXYAAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.0/static/bb6db8174a3df1c176a4539daed8efd3/72aae/button-order-bad.png",
                  "srcSet": ["/version/4.9.0/static/bb6db8174a3df1c176a4539daed8efd3/a2ead/button-order-bad.png 259w", "/version/4.9.0/static/bb6db8174a3df1c176a4539daed8efd3/6b9fd/button-order-bad.png 518w", "/version/4.9.0/static/bb6db8174a3df1c176a4539daed8efd3/72aae/button-order-bad.png 964w"],
                  "sizes": "(max-width: 964px) 100vw, 964px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
      `}</figure>{`
    `}</div>{`
  `}</div>
      </div>
      <h3>{`Use icons only for the most critical actions`}</h3>
      <p>{`Not all buttons in a group require an icon, but buttons with icons should always be of a higher priority than ones without icons. If the most critical action in a group doesn’t have an icon, don’t use icons in the remaining lower-level actions.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "964px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "51.35135135135135%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAAsTAAALEwEAmpwYAAABRUlEQVQoz32SvUoDQRDH740sbFQQ1Fio+BCWPoiNWAkWPoCFigmGfBhFhBRqEDkSYtRTEpt4uagxl93Zmd3NfcgpxOTEDMMwxf72/5+dNTbPdzfOdnzlAYAYDQBg7Dc5jx8wilapUCtqqQbwTwMAUmLgS/87A19qjbH7DU/1PeUNqSHn5LpCSmU9vx+mrGT6KZV+PjiyKneO1jRs0OCRHT7QJFRdVzdeeBiGe/vW5GxqYSW7uJqbmEpubZthqBkbgv/MKUCgEEhEdsut3bertXa56phlu+V0pRxxHoc5R8awx6La6fBcoZ49qedPG5l8/fK6iTg6c+x5AZTTpldbuD1dqX7MJI7nljLzy5npRHpt/YII/4UjPiooBCHRZ5ebZfvWtEs3zatS8+HxbZxyLBCF70nfi/YUBLLfp/iex8AAYvwn+QKFGiFgwGj5nwAAAABJRU5ErkJggg==')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.0/static/da5ffc1ccdee795b61dbd01dcae8e224/72aae/icons-good.png",
                  "srcSet": ["/version/4.9.0/static/da5ffc1ccdee795b61dbd01dcae8e224/a2ead/icons-good.png 259w", "/version/4.9.0/static/da5ffc1ccdee795b61dbd01dcae8e224/6b9fd/icons-good.png 518w", "/version/4.9.0/static/da5ffc1ccdee795b61dbd01dcae8e224/72aae/icons-good.png 964w"],
                  "sizes": "(max-width: 964px) 100vw, 964px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "964px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "51.35135135135135%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA+klEQVQoz6WRv04CQRCHeURLKyuIBUEboLKy8QlMaEyMhZ0FJQ0hBHNBH4DGGCMYg7cHd/tnZtmbvZC9VQ4IkBA3v2IymW/3y2zp+/7uq3WLWaaEUEee0ux1GAXPYIySct+QlBspYEhTIDpA+gMAiC6w/rKzzYWFkP7ivJArxndClvyELnEioID/xABNyDBkCJgmXE+nikX4/sGJ7MPj6OS0c17rn1W6F/UB59ILFLCCxWyO8xgVLOIEP8ecRTCeCCJ6ar+Vq73mVXDZGFzfvAixCee8awEo74zoaq3dlDGYWU2ElrS1Wm1p//J5tjbs17Ge3fDR//wfeAn9UC/cCoOfHwAAAABJRU5ErkJggg==')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.0/static/39634a4cd115bf7fc4137ba4ef5592b7/72aae/icons-bad.png",
                  "srcSet": ["/version/4.9.0/static/39634a4cd115bf7fc4137ba4ef5592b7/a2ead/icons-bad.png 259w", "/version/4.9.0/static/39634a4cd115bf7fc4137ba4ef5592b7/6b9fd/icons-bad.png 518w", "/version/4.9.0/static/39634a4cd115bf7fc4137ba4ef5592b7/72aae/icons-bad.png 964w"],
                  "sizes": "(max-width: 964px) 100vw, 964px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
      `}</figure>{`
    `}</div>{`
  `}</div>
      </div>
      <h3>{`Use ButtonGroup to show additional actions`}</h3>
      <p>{`Use ButtonGroup to show any additional actions related to the most critical action.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "964px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "51.35135135135135%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAvElEQVQoz2Po3DOjZdeUvz//fPny5SuJgOHgzRM7rh789eMnsubPn798+gRF+DT/+fn7z88/aKK/f33/+/fH378/fv/+jk/z5y+fP3/5jCZ649ar02efnjn39Oq1l58/f8XlIQZkDlxRZMIee4/Nrr5bvYK2vX7z/dOnX1j1M2AKffv6ddvOewuXXFu87Nr6Tbc/ffr25ct3YjV//fr1z5/v/8B+/vvnx9cvX3BFBHbN8KAmENpfKQAUaQYAm74xXOQb3CAAAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.0/static/79b221a95948e8dddc195c8faf944c0f/72aae/additional-actions.png",
                  "srcSet": ["/version/4.9.0/static/79b221a95948e8dddc195c8faf944c0f/a2ead/additional-actions.png 259w", "/version/4.9.0/static/79b221a95948e8dddc195c8faf944c0f/6b9fd/additional-actions.png 518w", "/version/4.9.0/static/79b221a95948e8dddc195c8faf944c0f/72aae/additional-actions.png 964w"],
                  "sizes": "(max-width: 964px) 100vw, 964px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
  `}</div>
        </div></div>
      <span className="horizontal-spacer" />
    </PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      